declare const ENV: string

export interface BannerModel {
  consent_url: string
  template_url: string
  data_domain_script: string
  enabled: boolean
}

export function getConfig(): BannerModel{
  if(ENV == "prod"){
    return require('./ProdConfig').bannerConfig
  }
  else{
    return require('./NonProdConfig').bannerConfig
  }
}
